import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE_DATASET = gql`
  mutation UpsertWorkspaceDataset($input: UpsertWorkspaceDatasetInput!) {
    workspace: upsertWorkspaceDataset(input: $input) {
      id
    }
  }
`;
